module.exports = __webpack_public_path__ + "static/media/fintechdemoday.c6a31967.png";